import { Field } from '@/ui'
import { connect, FieldArray, Field as FormikField } from 'formik'
import React from 'react'
import cl from 'classnames'
import { useTranslation } from 'react-i18next'
import { NOMINATION_EMPL_FIELDS } from '@/entity/nomination'
import { useSelector } from 'react-redux'
import { employerProfileSelectors } from '@features/employerProfile/model'

export const CommonFields = connect(() => {
	const { t } = useTranslation()
	const activeCompany = useSelector(employerProfileSelectors.activeCompany)

	const {dictValues} = useSelector((state) => ({
		dictValues: state.nomination.dictValues,
	}))

	let region = [{
		code: activeCompany?.ddistrictCode?.code,
		nameRu: activeCompany?.ddistrictCode?.rus,
		nameKz: activeCompany?.ddistrictCode?.kz,
	}]

	let oked = [{
		code: activeCompany?.dokedCode?.code,
		nameRu: activeCompany?.dokedCode?.rus,
		nameKz: activeCompany?.dokedCode?.kz,
	}]

	return (
		<div className={cl('flex', 'flex-column', 'gap-4')}>
			<div className={cl('flex', 'gap-4')}>
				<div className={cl('flex-1')}>
					<FormikField name={NOMINATION_EMPL_FIELDS.orgName}>
						{({ field, meta: { touched, error } }) => {
							return (
								<Field
									isRequired
									type="text"
									label={t('accidentsPage.view.organization')}
									placeholder={t('ckp_name')}
									disabled
									value={field.value}
									error={touched && error}
								/>
							)
						}}
					</FormikField>
				</div>
				<div className={cl('flex-1')}>
					<FormikField name={NOMINATION_EMPL_FIELDS.katoAB}>
						{({ field, meta: { touched, error } }) => {
							return (
								<Field
									isRequired
									type="text"
									fieldType='select'
									label={t('region')}
									placeholder={t('region')}
									options={region}
									disabled
									value={field.value}
									error={touched && error}
								/>
							)
						}}
					</FormikField>
				</div>
			</div>

			<div className={cl('flex', 'gap-4')}>
				<div className={cl('flex-2')}>
					<FormikField name={NOMINATION_EMPL_FIELDS.email}>
						{({ field, meta: { touched, error } }) => (
							<Field
								isRequired
								type="text"
								label={t('electronic_mail')}
								placeholder={t('electronic_mail')}
								error={touched && error}
								{...field}
							/>
						)}
					</FormikField>
				</div>

				<div className={cl('flex-1')}>
					<FormikField name={NOMINATION_EMPL_FIELDS.workPhone}>
						{({ field, meta: { touched, error } }) => (
							<Field
								isRequired
								// type="number"
								// min={0}
								// hideNumberArrows
								label={t('officePhone')}
								placeholder={t('officePhone')}
								error={touched && error}
								{...field}
							/>
						)}
					</FormikField>
				</div>

				<div className={cl('flex-1')}>
					<FormikField name={NOMINATION_EMPL_FIELDS.mobilePhone}>
						{({ field, meta: { touched, error } }) => (
							<Field
								isRequired
								// type="number"
								// min={0}
								// hideNumberArrows
								label={t('pension.payments.form.labels.phone')}
								placeholder={t('pension.payments.form.labels.phone')}
								error={touched && error}
								{...field}
							/>
						)}
					</FormikField>
				</div>
			</div>

			<div className={cl('flex-1', 'flex', 'gap-4')}>
				<div className={cl('flex-2')}>
					<FormikField name={NOMINATION_EMPL_FIELDS.directorFullName}>
						{({ field, meta: { touched, error } }) => (
							<Field
								isRequired
								label={t('nomination.fioDirector')}
								placeholder={t('nomination.fioDirector')}
								error={touched && error}
								{...field}
							/>
						)}
					</FormikField>
				</div>

				<div className={cl('flex-1')}>
					<FormikField name={NOMINATION_EMPL_FIELDS.foundationDate}>
						{({ field, meta: { touched, error } }) => (
							<Field
								isRequired
								fieldType="datePicker"
								label={t('nomination.foundationDate')}
								placeholder={t('nomination.foundationDate')}
								error={touched && error}
								{...field}
							/>
						)}
					</FormikField>
				</div>
			</div>

			<div className={cl('flex-1')}>
				<FormikField name={NOMINATION_EMPL_FIELDS.okedCode}>
					{({ field, meta: { touched, error } }) => {
						return (
							<Field
								isRequired
								type="text"
								fieldType='select'
								label={t('col_contract.industry')}
								placeholder={t('col_contract.industry')}
								options={oked}
								disabled
								value={field.value}
								error={touched && error}
							/>
						)
					}}
				</FormikField>
			</div>

			<div className={cl('flex-1')}>
				<FormikField name={NOMINATION_EMPL_FIELDS.categoryCode}>
					{({ field, meta: { touched, error } }) => (
						<Field
							fieldType="radio"
							label={t('nomination.create.category')}
							error={touched && error}
							options={dictValues.data?.subjectType}
							{...field}
						/>
					)}
				</FormikField>
			</div>
		</div>
	)
})